<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage" id="sec-3">
<h1 class="title" id="pz3-1">
					FINDING THEIR VOICES </h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitlepage.vue?2f1dfce1